import { number, bool } from 'prop-types';
import styled from 'styled-components';
import { useForm, useField } from 'react-final-form';
import FileUpload from '../../FileUpload';
import UploadPreview from '../../UploadPreview';
import NavigationButtons from '../NavigationButtons';
import { TitleWrapper } from '../common';
import bgForestSrc from '../../../../assets/images/bg-missing-preview.jpg';
import bgMillSrc from '../../../../assets/images/bg-missing-preview-mill.jpg';
import { MULTIMEDIA_TYPES } from '../../../../config';

const Wrapper = styled.div`
  max-width: 1000px;
  margin: 0 auto;
`;

const Separator = styled.div`
  margin-bottom: 16px;
`;

function MediaUpload({
  currentStep,
  hasValidationErrors
}) {

  const { change, submit } = useForm();

  const {
    input: { value: uploadType },
  } = useField(`uploadType`, {
    subscription: { value: true },
  });

  const {
    input: { value: files },
  } = useField(`files`, {
    subscription: { value: true },
  });

  const getImagePreview = file => {
    if(MULTIMEDIA_TYPES.includes(uploadType)) {
      return ['image/jpeg', 'image/png'].includes(file.type) ? URL.createObjectURL(file) : bgForestSrc;
    }

    return uploadType === 'mill' ? bgMillSrc : bgForestSrc;
  }

  return (
    <>
      <TitleWrapper>
        <p>Media files upload</p>
        <p>
          Please select project media files to be uploaded.
        </p>
      </TitleWrapper>
      <Wrapper>
        <FileUpload onChange={data =>
          change('files', [
            ...files,
            ...data.map(item => ({
              ...item,
              preview: getImagePreview(item.file),
            }))
          ]
        )} />

        <Separator />

        {
          files.length > 0 && (
          <UploadPreview items={files} onRemove={idx => {
            change('files', [
              ...files.slice(0, idx),
              ...files.slice(idx + 1),
            ]);
          }} />
        )}

      </Wrapper>

      <NavigationButtons
        currentStep={currentStep}
        isNextDisabled={hasValidationErrors}
        nextBtnLabel="Create project"
        onBackClick={() => {
          change('files', []);
          change('currentStep', currentStep - 1);
        }}
        onNextClick={submit} />
    </>
  );
}


MediaUpload.propTypes = {
  currentStep: number.isRequired,
  hasValidationErrors: bool.isRequired,
}

export default MediaUpload;